export { ACCESS_LEVEL_ENTITY } from "./accessLevelEntity";
export { default as accessLevelEntityLocale } from "./accessLevelEntity.locale";
